// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import DashboardController from "./dashboard_controller"
application.register("dashboard", DashboardController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import ConfirmController from "./confirm_controller"
application.register("confirm", ConfirmController)

import ColorPickerController from "./color_picker_controller"
application.register("color-picker", ColorPickerController)

import ImageUploadController from "./image_upload_controller"
application.register("image-upload", ImageUploadController)

import MapEditorController from "./map_editor_controller"
application.register("map-editor", MapEditorController)

import InteractiveMapController from "./interactive_map_controller"
application.register("interactive-map", InteractiveMapController)
